export default __webpack_public_path__ + "static/media/slide3.13d6e481.jpg";